<!--抄表管理-->
<template>
		<div class="meterManagerBody">
			<MeterManagerList ref="meterList" v-show="showPage == 0" @viewDetails="viewDetails"></MeterManagerList>
			<MeterManagerDetails ref="meterDetails" v-show="showPage == 1" @closeDetails="showMeterList"></MeterManagerDetails>
		</div>
</template>

<script>
	import userManageUnitTree from '@/components/module/tree/userMangeUnitTree.vue'
	import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import MeterManagerList from './MeterManagerList.vue'
	import MeterManagerDetails from './MeterManagerDetails.vue'
	import meterManagerStore from './meterManagerStore.js'
	export default {
		components: {
			userManageUnitTree,
			virtualDeviceTree,
			treeBody,
			MeterManagerList,
			MeterManagerDetails
		},
		props: {},
		data() {
			return {
				showPage: 0,
			}
		},
		created() {},
		mounted() {
			meterManagerStore.commit("setNowUser", this.nowUser)
			meterManagerStore.commit("setNowUnit", this.nowUnit)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return meterManagerStore.state.nowUnit
			},
			nowUser() {
				return this.$store.userStore.state.nowUserInfo
			}
		},
		watch: {
			nowUser(nv, ov) {
				meterManagerStore.commit("setNowUser", nv)
			}
		},
		methods: {
			checkUnit(item) {
				meterManagerStore.commit('setNowUnit', item)
				this.showPage = 0
			},
			autoSelectMethod(item, index) {
				return item.type == 0
			},
			isGroup(item) {
				return !isempty(item.next)
			},
			viewDetails(item) {
				//console.info("item:"+JSON.stringify(item));
				var billingMode = this.getBillingMode(item.billingMode);
				item.billingMode = billingMode;
				item.minBeginTime = this.formatTime(item.minBeginTime);
				item.maxEndTime = this.formatTime(item.maxEndTime);
				item.useElectric = item.useElectric.toFixed(2);
				this.$refs.meterDetails.setItem(item)
				this.showPage = 1
			},
			showMeterList() {
				this.showPage = 0
				this.$refs.meterList.getDataList()
			},
			getBillingMode(e){
				switch(e) {
					case 'StepBilling':
						return  e = '阶梯计费'
						break
					case 'PeakAndValleyBilling':
						return  e = '费率计费'
						break
					case 'SingleBilling':
						return  e = '单价计费'
						break
					default:
						return e;
				}

			},

			formatTime(e) {
				return new Date(e).format('yyyy-MM-dd hh:mm:ss')
			}
		}
	}
</script>

<style scoped>
	.meterManagerBody{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}
</style>
